import * as React from 'react'
import { connect } from 'react-redux'
import { getSamples } from '../Voices.actions'
import { VoiceSampleListComponent } from './VoiceSampleList'
import { IVoicesState } from '../Voices.reducer'
import { IVoiceBunnySample } from '../types'

export interface IVoiceSampleListContainerProps {
  onSelect: (sample: IVoiceBunnySample) => void
  talendID: string
  filter: object
}

const stateToProps = (
  { voices }: { voices: IVoicesState },
  { filter }: IVoiceSampleListContainerProps
) => {
  const cacheKey = JSON.stringify(filter)
  const samples = voices.samples[cacheKey] || {}
  return {
    cacheKey,
    loading: samples.loading || false,
    results: samples.results || [],
  }
}

export const dispatchToProps = {
  getSamples,
}

export const VoiceSampleList = connect(
  stateToProps,
  dispatchToProps
)(VoiceSampleListComponent) as React.SFC<IVoiceSampleListContainerProps>



// WEBPACK FOOTER //
// src/features/Voices/VoiceSampleList/VoiceSampleList.container.ts